import src from "IMAGE";
export default { src, width: 880, height: 800, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/webp;base64,UklGRm4AAABXRUJQVlA4TGIAAAAvB4ABAM1VICICHgiADQIAAIBGb+b8BAgIAQCAEAAAAAAAAAAAAAAAAAAAAAAAAAByd1UlurxKbp4AAICIyFKTb+IcUK2HRU1tTdKbyC92VRG2cxruj38YXb8nSMDPcokcMg=="};
